

<mat-card>
  <mat-card-header>
    <h2>Asset Data Import</h2>
  </mat-card-header>
  <mat-card-content>
    <div class="upload-section">
      <span class="upload-input">
        <label for="file">Choose data file for upload (.xlsx, .xls, .csv)</label>
        <input type="file" accept=".xlsx,.xls,.csv" #fileInput id="file" (change)="fileInputChanged($event.target.files)">
      </span>
      <button mat-raised-button color="primary"(click)="uploadFile()" [disabled]="selectedFile == null">Upload</button>
    </div>
    <div class="error-section" *ngIf="error">
      <b>Error: {{error.title}} - </b> {{error.friendlyMessage}}
    </div>
    <div>
      <mat-divider></mat-divider>
      <div *ngIf="rowsLoaded">
        Select rows you want to import. Changes won't persist to server until you save.
      </div>
      <div class="table-panel">
        <div class="mat-elevation-z8">
          <div class="mat-table-wrapper">
            <mat-table #table [dataSource]="importRows" matSort matSortDirection="asc" matSortDisableClear cdkDropListGroup [cdkDropListGroupDisabled]="true"
            cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="columns.dropListDropped($event)">
        
            <ng-container matColumnDef="selectedForImport">
              <mat-header-cell [crud-column-header]="columns.column('selectedForImport')" *matHeaderCellDef mat-sort-header cdkDropList
                cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)"
                cdkDrag class="search-column-small" i18n="@@type.Asset.selectedForImport">
                Import
              </mat-header-cell>
              <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'selectedForImport')">
                <mat-icon *ngIf="element.selectedForImport">check_box</mat-icon><mat-icon *ngIf="!element.selectedForImport">check_box_outline_blank</mat-icon>
              </mat-cell>
            </ng-container>

              <app-asset-search-result-columns [cellClassFn]="cellClass" [columns]="columns"></app-asset-search-result-columns>
        
              <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
              <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"  [ngClass]="rowClass(row)" (click)="toggleSelected(row)"></mat-row>
        
            </mat-table>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions *ngIf="rowsLoaded">
    <button mat-raised-button color="primary" (click)="import()" [disabled]="!importEnabled()" matTooltip="Creates all selected rows as Assets">Import</button>
    <button mat-raised-button color="accent2" (click)="selectAll()"><mat-icon>check_box</mat-icon> Select All</button>
    <button mat-raised-button color="accent2" (click)="deselectAll()"><mat-icon>check_box_outline_blank</mat-icon> Deselect All</button>
  </mat-card-actions>
</mat-card>